module.exports = __webpack_public_path__ + "static/media/audio-pdf-thumbnail.22e774fa.png";